import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import BrandWheelLoader from "../../../BrandWheelLoader";
import { LOADER_V2_ENABLED } from "../../../BrandWheelLoader/loaderV2Flag";

// The busy overlay for the Wheel view and Wheel-gallery actions. Additive swap:
// the generic MUI CircularProgress is replaced by the on-brand BrandWheelLoader
// (the brand Wheel filling segment by segment) — same `open` prop, same Backdrop
// behaviour, no API change. tone="dark" (QA-104) keeps the jewel segments readable
// on the dimmed MUI Backdrop scrim; role=status announces the busy state to AT.
//
// LOADER-V2 (design-doc variant A): the MUI Backdrop already viewport-centres the
// mark, so on a full-screen busy overlay the Wheel should read LARGE + consistent
// with the rest of the full-page loaders. Byte-identical `medium` when the flag is OFF.
export default function BackdropSpinner({ open = false }) {
  return (
    <div>
      <Backdrop sx={{ color: "#fff", zIndex: 10000 }} open={open}>
        <BrandWheelLoader
          variant={LOADER_V2_ENABLED ? "page" : "medium"}
          reroll={LOADER_V2_ENABLED || undefined}
          tone="dark"
          label="Loading…"
        />
      </Backdrop>
    </div>
  );
}
